import React from 'react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';

class HideButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      share: this.props.bid.share
    }
  }

  hideBid(bid) {
    this.props.editBid(this.props.bid.id, {
      share: !this.props.bid.share
    });
  }

  // Set State when props change
  // static getDerivedStateFromProps(bid, bid)
  componentWillReceiveProps(nextProps){
    if (nextProps.bid.share !== this.props.bid.share) {
      this.setState({ share: nextProps.bid.share})
    }
  }

  render() {
    return (
      <Button 
        bsStyle={this.state.share ? 'success' : 'danger'} 
        // style={{ marginLeft: 0 }}
        onClick={() => this.hideBid(this.props.bid)}
      >
        {this.state.share && (
          <i className="fa fa-eye" />
        )}
        {!this.state.share && (
          <i className="fa fa-eye-slash" />
        )}
      </Button>
    );
  }
}
export default HideButton;


// WEBPACK FOOTER //
// src/routes/tours/components/HideButton.js